import PropTypes from 'prop-types';
import Button from '../Button';
import { DeprecatedButtonContainer } from '../ButtonContainer';
import Modal from '../Modal';

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    message: PropTypes.string,
    callbacks: PropTypes.shape({
        onConfirm: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
    }).isRequired,
};

interface Props {
    isOpen: boolean;
    callbacks: {
        onCancel: () => void;
        onConfirm: () => void;
    };
    message?: string;
}

export default function InterceptorModal({
    isOpen,
    message = 'Are you sure you want to leave?',
    callbacks: { onCancel, onConfirm },
}: Props) {
    return isOpen ? ( // not using the isOpen prop so the portal is always rendered last, and this stays above other modals
        <Modal title="Unsaved changes will be lost" size="MD_WIDTH" isOpen onClose={onCancel}>
            <div>
                <p>{message}</p>
            </div>
            <DeprecatedButtonContainer>
                <Button onClick={onConfirm} autoFocus>
                    Leave
                </Button>
                <Button kind="PRIMARY" onClick={onCancel}>
                    Stay
                </Button>
            </DeprecatedButtonContainer>
        </Modal>
    ) : null;
}

InterceptorModal.propTypes = propTypes;
